class InstagramCards extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initVideos();
    }

    initVideos() {
        const videoElements = this.querySelectorAll('.section-instagram-card video');

        videoElements.forEach(video => {
            video.addEventListener('click', () => {
                const isCurrentlyUnmuted = !video.muted;

                // Mute all videos first
                videoElements.forEach(v => v.muted = true);

                // If this video was muted before, unmute it
                if (!isCurrentlyUnmuted) {
                    video.muted = false;
                    video.play().catch(error => {
                        console.warn('Video playback failed:', error);
                    });
                }
                // If already unmuted, now it’s muted (toggle off) — do nothing more
            });
        });
    }
}

customElements.define('instagram-cards', InstagramCards);
